/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { ILinkOptions } from 'src/adhoc/store/types/StateTypes';
import i18n from '../../../../../i18n/AdHocBundle.properties';

function encodeFieldValue(value: string) {
    if (value === i18n['adhoc.node.other.node']) {
        return 'other_node';
    }
    if (value === i18n['adhoc.node.total.node']) {
        return 'total_node';
    }
    return value;
}

export function linkObjectToLinkData(parameters: any) {
    const data: any = {};
    if (parameters.measures) {
        data.Measures = parameters.measures;
    }
    if (parameters.values) {
        const { values } = parameters;
        values.forEach((paramValue: any) => {
            if (paramValue.key) {
                data[paramValue.key] = encodeFieldValue(paramValue.value);
            }
        });
    }

    return data;
}

export function getOutputParamFromMeasure(measure: any) {
    return measure.hierarchicalName || measure.field;
}

export function getOutputParamsKeyFromField(field: any) {
    return field.id || field.hierarchicalName || field.field;
}

export function getEvents(linkOptions: ILinkOptions | undefined): any {
    const hcEvents: any = {};
    if (linkOptions && linkOptions.events) {

        const visualizeMouseClick = linkOptions.events.click;
        if (visualizeMouseClick) {
            hcEvents.click = function clickEvent(event: any) {
                const data = linkObjectToLinkData(event.point.linkOutputParams);
                visualizeMouseClick(event, data, undefined, undefined);
            };
        }

        const visualizeMouseOver = linkOptions.events.mouseover;
        if (visualizeMouseOver) {
            hcEvents.mouseOver = function overEvent(event: any) {
                const data = linkObjectToLinkData(event.target.linkOutputParams);
                visualizeMouseOver(event, data, undefined, undefined);
            };
        }

        const visualizeMouseOut = linkOptions.events.mouseout;
        if (visualizeMouseOut) {
            hcEvents.mouseOut = function outEvent(event: any) {
                const data = linkObjectToLinkData(event.target.linkOutputParams);
                visualizeMouseOut(event, data, undefined, undefined);
            };
        }
    }
    return hcEvents;
}
